export default (...functions: ((_1: any) => any)[]) => (value: any) =>
  functions.reduceRight((currentValue, currentFunction) => currentFunction(currentValue), value);
